// extracted by mini-css-extract-plugin
module.exports = {"field":"_81O9L","icon":"yoRjO"};